import * as React                                     from 'react'
import { connect }                                    from 'react-redux'
import { bindActionCreators }                         from 'redux';

import { Reference, ReferenceCategory, UiError }      from '../domain/models'
import { actionCreators, ReferencesAppState }         from '../store/references'
import { ReferencesContainer }                        from '../components/ReferencesContainer'
import { ReferencesFilter }                           from '../components/ReferencesFilter'
import { PagingButtons, PagingButtonsGrouped }        from '../components/PagingButtons'
import { PagesDisplay }                               from '../components/PagesDisplay'

interface Props {
    isLoading:                                        boolean
    showFilter:                                       boolean
    error:                                            UiError
    page:                                             number

    references:                                       Reference[]
    lastPage:                                         number
    referenceCategories:                              ReferenceCategory[]
    years:                                            number[]

    selectedYears:                                    number[]
    selectedCategoriesIds:                            number[]

    actions:                                          typeof actionCreators
}

interface State {
    /* empty */
}

class ReferencesApp extends React.Component<Props, State> {
    constructor( props: Props ) {
        super( props )
    }

    handleSelectYear = ( year: number ) => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.paginationToPage(1)

        const changedselectedYears = selectedYears.concat(year)

        actions.selectYear( year )
        actions.fetchReferences(1,changedselectedYears,selectedCategoriesIds)
    }

    handleDeSelectYear = ( year: number ) => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.paginationToPage(1)

        const indexOfYear = selectedYears.indexOf( year );
        const changedYear = selectedYears
            .slice( 0, indexOfYear )
            .concat(selectedYears.slice( year + 1 ) )

        actions.paginationToPage(1)
        actions.deSelectYear( year )
        actions.fetchReferences(1,changedYear,selectedCategoriesIds)
    }

    handleSelectCategory = async ( categoryId: number ) => {
        const { actions, page, selectedYears, selectedCategoriesIds } = this.props

        actions.paginationToPage(1)

        const changedSelectedCategoriesIds = selectedCategoriesIds.concat(categoryId)

        actions.selectReferenceCategory( categoryId )
        actions.fetchReferences(1,selectedYears,changedSelectedCategoriesIds)
    }

    handleDeSelectCategory = ( categoryId: number ) => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.paginationToPage(1)

        const indexOfCategory = selectedCategoriesIds.indexOf( categoryId );
        const changedSelectedCategoriesIds = selectedCategoriesIds
            .slice( 0, indexOfCategory )
            .concat(selectedCategoriesIds.slice( indexOfCategory + 1 ) )

        actions.deSelectReferenceCategory( categoryId )
        actions.fetchReferences(1,selectedYears,changedSelectedCategoriesIds)
    }

    handleGoNextPage = () => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.paginationNextPage()
        actions.fetchReferences(page + 1,selectedYears,selectedCategoriesIds)
    }

    handleGoPreviousPage = () => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.paginationPreviousPage()
        actions.fetchReferences(page - 1,selectedYears,selectedCategoriesIds)
    }

    handleGoPage = (page: number) => {
        const { actions, selectedYears, selectedCategoriesIds } = this.props

        actions.paginationToPage(page)
        actions.fetchReferences(page,selectedYears,selectedCategoriesIds)
    }

    handleShowFilter = () => {
        const { actions } = this.props

        actions.showFilter()
    }

    handleHideFilter = () => {
        const { actions } = this.props

        actions.hideFilter()
    }

    handleApplyFilter = () => {
        const {actions, page, selectedYears, selectedCategoriesIds} = this.props

        actions.fetchReferences(page,selectedYears,selectedCategoriesIds)
    }

    handleClearFilter = () => {
        const {actions, page } = this.props

        actions.paginationToPage(1)
        actions.clearFilter()

        actions.fetchReferences(page,[],[])
    }

    unbindFancyBoxTriggers = () => {
        let code = '$(\'.fancybox-trigger\').unbind(\'click\');'

        eval(code)
    }

    // $(".fancybox-trigger").click(function () {
    //     $("a[rel='" + $(this).data('trigger-rel') + "']").eq(0).trigger('click');
    //
    //     return false;
    // });
    applyFancyBox = () => {
        let code = '$( ".fancybox-trigger" ).click( function () {\n' +
            '            $( "a[rel=\'" + $( this ).data( \'trigger-rel\' ) + "\']" ).eq( 0 ).trigger( \'click\' );\n' +
            '\n' +
            '            return false;\n' +
            '        } );'

        eval( code )
    }

    renderShowHideFilterButton = (showFilter: boolean) => {
        if ( !showFilter ) {
            return (
                <button className="btn btn-default" onClick={ this.handleShowFilter }>Zobraz filtr referencí</button>)
        } else {
            return (
                <button className="btn btn-danger" onClick={ this.handleHideFilter }>Skryj filtr referencí</button>)
        }
    }

    componentWillUpdate() {
        this.unbindFancyBoxTriggers()
    }

    render() {
        const {
            references,
            referenceCategories,
            page,
            years,
            showFilter,
            selectedCategoriesIds,
            selectedYears,
            lastPage
        } = this.props

        return (
            <div>
                <br/>

                <div className='row'>
                    { this.renderShowHideFilterButton(showFilter) }

                    <PagingButtonsGrouped
                        currentPage=                { page }
                        goNextPageClick=            { this.handleGoNextPage }
                        goBackPageClick=            { this.handleGoPreviousPage }
                        lastPage={lastPage}/>
                </div>

                <div className='row'>
                    <div className='text-center'>
                        <PagesDisplay
                            selectedPage=           { page }
                            lastPage=               { lastPage }
                            onSelectPageFn=         {this.handleGoPage}/>
                    </div>
                </div>

                <br/>

                <ReferencesFilter
                    showFilter=                     { showFilter }
                    selectedCategoriesIds=          { selectedCategoriesIds }
                    selectedYears=                  { selectedYears }
                    referenceCategories=            { referenceCategories }
                    years=                          { years }

                    onReferenceCategorySelectFn=    { this.handleSelectCategory }
                    onReferenceCategoryDeselectFn=  { this.handleDeSelectCategory }

                    onYearSelectFn=                 { this.handleSelectYear }
                    onYearDeSelectFn=               { this.handleDeSelectYear }

                    onResetFilterFn=                { this.handleClearFilter }
                    onApplyFilterFn=                { this.handleApplyFilter }
                />

                <ReferencesContainer references=    { references }/>

                <div className='row'>
                    <div className='text-center'>
                        <PagesDisplay
                            selectedPage=           { page }
                            lastPage=               { lastPage }
                            onSelectPageFn=         { this.handleGoPage }/>
                    </div>
                </div>

                <div className='row'>
                    <PagingButtons
                        currentPage=                { page }
                        goNextPageClick=            { this.handleGoNextPage }
                        goBackPageClick=            { this.handleGoPreviousPage }
                        lastPage={lastPage}/>
                </div>

                <br/>
                <br/>
                <br/>

            </div>)
    }

    componentDidMount(): void {
        const { actions, page, years, selectedCategoriesIds } = this.props

        actions.fetchReferences( page, years, selectedCategoriesIds )
        actions.fetchReferenceCategories()
        actions.fetchReferenceYears()
    }

    componentDidUpdate(){
        this.applyFancyBox()
    }
}

function mapStateToProps( state: ReferencesAppState ) {
    return {
        isLoading:                                    state.isLoading,
        showFilter:                                   state.showFilter,
        error:                                        state.error,
        page:                                         state.page,

        references:                                   state.references,
        lastPage:                                     state.lastPage,
        referenceCategories:                          state.referenceCategories,
        years:                                        state.years,

        selectedYears:                                state.selectedYears,
        selectedCategoriesIds:                        state.selectedCategoriesIds
    }
}

function mapDispatchToProps( dispatch: any ) {
    return {
        actions: bindActionCreators( actionCreators, dispatch )
    }
}

export default connect( mapStateToProps, mapDispatchToProps )( ReferencesApp )


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/containers/ReferencesApp.tsx
 **/